<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.APPROVAL.POPUP.TITLE') }}</i>
                </dt>
                <dd>

                    <table class="create_table mt-20">
                        <colgroup>
                            <col width="154px">
                            <col class="*">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    {{ $t('FIELD.GLOBAL.SUBJECT') }}
                                    <!-- <em class="txt_mandatory">*</em> -->
                                </th>
                                <td>
                                    {{ detail.KNOWLEDGE_TITLE }}
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.SURVEY.TO') }}</th>
                                <td>
                                    <span class="mr10">{{ detail.TO_NM }}</span>    <!-- 컨텐츠 최종 수정자 이름 -->
                                    <span class="mr10">{{ detail.CORP_NM }}</span>  <!-- 컨텐츠 최종 수정자 법인명 -->
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.OPINION') }}</th>
                                <td>
                                    <textarea
                                        class="text_textarea w100p"
                                        v-model="approveOpinion"
                                        rows="4"
                                        maxlength="500"
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine mt-0">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnCancel">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnSend">
                                {{ $t('BUTTON.GLOBAL.SEND') }}
                                <em class="ico_infoW_btn">
                                    <i class="tooltip fl_right">
                                        {{ $t('MESSAGE.REQUEST.SHARING.SEND.TOOLTIP') }}
                                    </i>
                                </em>
                            </a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

const fetchDetail = knowledgeId => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/getKnowledgeReqShareDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'RequestSharingToPopup',
    props: {
        knowledgeId:    { required: true },
        rtnFunc:        { type: Function }
    },
    data() {
        return {
            detail: {},
            approveOpinion: ''
        }
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
            loginRhq: 'getLoginRhq',
        }),
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return fetchDetail(this.knowledgeId)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        btnCancel() {
            if(typeof this.rtnFunc === 'function') {
                this.rtnFunc();
            };

            this.$emit('close');
        },
        btnSend() {
            if(SDLUtil.isNull(this.approveOpinion)) {
                return SDLUtil.alert('MESSAGE.REQUEST.SHARING.ENTER.OPINION');

            } else {
                let that = this,
                    msgSend = SDLUtil.getMsgProp('BUTTON.GLOBAL.SEND'),
                    params = {
                        KNOWLEDGE_ID: this.knowledgeId,
                        TITLE       : this.detail.KNOWLEDGE_TITLE,
                        FR_NM       : SDLUtil.getLoginedUserInfo().loginName,
                        FR_LEVEL    : this.deptLevelCd,
                        FR_RHQ      : this.loginRhq,
                        TO_NM       : this.detail.TO_NM,
                        TO_EMAIL    : this.detail.TO_EMAIL,
                        APRV_OPINION: this.approveOpinion
                    };

                SDLUtil.confirm({
                    title: 'BUTTON.GLOBAL.SEND',
                    msg: SDLUtil.getMsgProp('MESSAGE.CONFIRM.OPERATION', [msgSend]),
                    onOkEvt: () => {
                        return  axios.post(
                                    `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/saveRequestSharing.skp`,
                                    qs.stringify(params),
                                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                                )
                                .then(res => {
                                    let data = res.data;
                                    if(data.msg) {
                                        SDLUtil.alert({
                                            title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                            msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                            onOkEvt: () => {
                                                that.rtnFunc(true);
                                                that.$emit('close');
                                            }
                                        });
                                    }
                                })
                                .catch(err => {
                                    SDLUtil.errorAlert(err);
                                });
                    }
                });
            };
        }
    },
    created() {
        this.initLoad().then( data => {
            if(data.detail.rowCount > 0) {
                this.detail = data.detail.rowData[0];
                SDLUtil.showLoadingBar(false);

            } else {
                SDLUtil.alert({
                    msg: 'MESSAGE.GLOBAL.NO.DATA',
                    onOkEvt: () => {
                        this.btnCancel();
                    }
                });

                SDLUtil.showLoadingBar(false);
            }
        });
    },
    mounted() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/RequestSharingToPopup.vue